import styled, { createGlobalStyle } from 'styled-components';

export const RAIL_WIDTH = 72;
export const PANEL_WIDTH = 230;

export const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${(props) =>
      props.theme.colors.background.light}!important;
  }
`;

export const LayoutContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const ContentArea = styled.div`
  margin-left: ${(props) =>
    props.panelOpen ? `${RAIL_WIDTH + PANEL_WIDTH}px` : `${RAIL_WIDTH}px`};
  min-height: 100vh;
  transition: margin-left 300ms cubic-bezier(0.4, 0, 0.2, 1);
`;
